import React, { useEffect, useState } from "react";
import { Select } from "@gw/web-basic-components";
import type { ColOptionsResponse, ColSelectProps } from "./dto";

const ColSelect = (props: ColSelectProps) => {
  const { val, setVal, requestConfig, colIndex } = props;
  const { apis, useRequest } = props.configProvider;

  const [, fetchOptions] = useRequest<any, ColOptionsResponse>(
    apis[requestConfig?.apiName || props.tableName][
      requestConfig?.fetchName || "alternatives"
    ]
  );

  const [options, setOptions] = useState([]);

  /**
   * 获取下拉框备选项
   */
  const getOptions = async () => {
    if (props.options) {
      setOptions(props.options);
      return;
    }
    const { changeType, optionLabel, optionValue } = requestConfig || {};
    const params = {
      type: changeType || colIndex,
      query: val,
    };
    const res = await fetchOptions(params);
    let newRes = res.dataList;
    if (optionLabel || optionValue) {
      newRes = res.dataList.map((m) => {
        const newItem = { ...m };
        if (optionLabel) {
          newItem["label"] = m[optionLabel];
        }
        if (requestConfig?.optionValue) {
          newItem["value"] = m[optionValue] || m["value"][optionValue];
        }
        return newItem;
      });
    } else {
      const resSet = new Set(res.dataList.map((m) => m.value));
      const newList = [];
      resSet.forEach((m) => {
        newList.push({ value: m });
      });
      newRes = newList;
    }
    setOptions(newRes);
  };

  /**
   * 下拉框筛选子项
   */
  const handleFilter = (input: string, option: any) => {
    const { label } = option;
    if (typeof label === "string")
      return label?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0;
    return false;
  };

  useEffect(() => {
    getOptions();
  }, []);

  return (
    <Select
      size="small"
      value={val}
      onSelect={setVal}
      options={options}
      showSearch
      optionFilterProp="children"
      filterOption={handleFilter}
      style={{ width: 150 }}
    />
  );
};

export default ColSelect;
